import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AcceptInvite from "./pages/AcceptInvite";
import Layout from "./components/Layout";
import EmployeeClock from "./pages/EmployeeClock";
import History from "./pages/History";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Stores from "./pages/Stores";
import Shifts from "./pages/Shifts";
import Corrections from "./pages/Corrections";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Assignments from "./pages/Assignments";
import AuditLog from "./pages/AuditLog";
import Landing from "./pages/Landing";
import Leads from "./pages/Leads";

import "./App.css";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="text-zinc-500 font-mono text-sm tracking-wider">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleRouter() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "employee") return <Navigate to="/clock" replace />;
  return <Navigate to="/dashboard" replace />;
}function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route path="/home" element={<RoleRouter />} />
            <Route path="/clock" element={<EmployeeClock />} />
            <Route path="/history" element={<History />} />
            <Route
              path="/dashboard"
              element={
                <Protected roles={["admin", "supervisor"]}>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/users"
              element={
                <Protected roles={["admin"]}>
                  <Users />
                </Protected>
              }
            />
            <Route
              path="/stores"
              element={
                <Protected roles={["admin"]}>
                  <Stores />
                </Protected>
              }
            />
            <Route
              path="/shifts"
              element={
                <Protected roles={["admin"]}>
                  <Shifts />
                </Protected>
              }
            />
            <Route
              path="/corrections"
              element={
                <Protected roles={["admin", "supervisor", "employee"]}>
                  <Corrections />
                </Protected>
              }
            />
            <Route
              path="/reports"
              element={
                <Protected roles={["admin", "supervisor"]}>
                  <Reports />
                </Protected>
              }
            />
            <Route
              path="/settings"
              element={
                <Protected roles={["admin"]}>
                  <Settings />
                </Protected>
              }
            />
            <Route
              path="/assignments"
              element={
                <Protected roles={["admin", "supervisor"]}>
                  <Assignments />
                </Protected>
              }
            />
            <Route
              path="/audit-log"
              element={
                <Protected roles={["admin"]}>
                  <AuditLog />
                </Protected>
              }
            />
            <Route
              path="/leads"
              element={
                <Protected roles={["admin"]}>
                  <Leads />
                </Protected>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
